var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", [
        _c("div", { staticClass: "topFixed" }, [
          _c("img", {
            staticClass: "img",
            attrs: { src: require("../assets/logo144.jpg"), alt: "" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("首页")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-main",
        { staticStyle: { "margin-top": "50px" } },
        [
          _c(
            "el-carousel",
            { attrs: { height: _vm.bannerHeight + "px", type: "card" } },
            _vm._l(_vm.bannerList, function(item, index) {
              return _c("el-carousel-item", { key: index }, [
                _c("h3", { staticClass: "small" }, [
                  _c("img", { attrs: { src: item.url, alt: "" } })
                ])
              ])
            }),
            1
          ),
          _vm._v(" "),
          _c("h2", { staticStyle: { "margin-top": "50px" } }, [
            _vm._v("近期热卖")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "product-list" },
            _vm._l(_vm.productList, function(item, index) {
              return _c("div", { key: index, staticClass: "product-item" }, [
                _c("img", {
                  staticClass: "product-img",
                  attrs: { src: item.url, alt: "" }
                }),
                _vm._v(" "),
                _c("h5", [_vm._v(_vm._s(item.name))])
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "app-detail" }, [
            _c("img", {
              staticClass: "appLogo",
              attrs: { src: require("../assets/logo144.jpg"), alt: "" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "app-text" }, [
              _c("p", [
                _vm._v("拔河网电动车配件平台,致力于更好的服务电动车配件批发商")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("把控风险，和谐共生，网罗天下")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "app-list" },
            _vm._l(_vm.appList, function(item, index) {
              return _c("div", { key: index, staticClass: "app-item" }, [
                _c("img", {
                  staticClass: "app-img",
                  attrs: { src: item.url, alt: "" }
                })
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "codeBox" }, [
            _c("div", { staticClass: "left" }, [
              _c("h5", [_vm._v("关注公众号")]),
              _vm._v(" "),
              _c("img", {
                attrs: { src: require("../assets/gzh.jpg"), alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c("h5", [_vm._v("下载APP（安卓版）")]),
              _vm._v(" "),
              _c("div", { staticClass: "imgBox" }, [
                _c("img", {
                  staticClass: "appImg",
                  attrs: { src: require("../assets/app.png"), alt: "" }
                })
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "top" }, [
          _c("div", [_vm._v("鲁ICP备2021039168号-2")]),
          _vm._v(" "),
          _c("div", [_vm._v("|")]),
          _vm._v(" "),
          _c("div", [_vm._v("联系地址：山东省济南市天桥区丁太鲁大街828号")]),
          _vm._v(" "),
          _c("div", [_vm._v("|")]),
          _vm._v(" "),
          _c("div", [_vm._v("联系方式：17077471234")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bottom" }, [
          _vm._v("\n      ©2018-2023 云分达 版权所有 并保留所有权利\n    ")
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-469af010", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469af010","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 